import { useMutation } from '@tanstack/react-query';
import { SendResetPasswordLinkRequest } from '@/types/request/SendResetPasswordLinkRequest';
import { BackendErrorResponse } from '@/types/response/Api/BackendErrorResponse';
import { BackendSuccessResponse } from '@/types/response/Api/BackendSuccessResponse';
import BackendClient from '@/api/backendClient.ts';
import { transformBackendErrors } from '@/utils/transformBackendErrors.ts';

const useSendResetPasswordLink = () => {
  const mutationFn = async (request: SendResetPasswordLinkRequest) => {
    return sendResetPasswordLink(request);
  };

  return useMutation({
    mutationFn,
  });
};

export default useSendResetPasswordLink;

async function sendResetPasswordLink(request: SendResetPasswordLinkRequest): Promise<{ message: string }> {
  try {
    const response = await BackendClient.post<BackendSuccessResponse<{ message: string }>>(
      '/api/auth/forgot-password',
      request
    );

    return response.data.data;
  } catch (error: any) {
    if (error.response && error.response.data) {
      const errorResponse = error.response.data as BackendErrorResponse;

      throw new Error(transformBackendErrors(errorResponse).join(', '));
    }

    throw new Error(error.message ?? 'An error occurred while sending reset password link.');
  }
}
